var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(false)?_c('a',{staticClass:"mb-2",attrs:{"target":"_blank","href":_vm.googleDocs}},[_vm._v(" 새창으로 보기(google docs) ")]):_vm._e(),(_vm.pdfUrl)?_c('PdfViewer',{attrs:{"url":_vm.pdfUrl,"width":'100%'}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }